
/*
Author: Vinod
Date: 17/01//2020
Issue Description: validation issue.
search_string: PL_2453
*/

<template>
    <div class="datepicker">
        <datepicker
         :placeholder="placeholder"
          v-model="date"
          :value="value"
          :format="formatDate"
          :name="name"
          :data-vv-name="name"
          @input="onSelected"
          @closed="$emit('blur')"
          v-validate="validations"
          :disabled = "disable"
          :open-date="openDate"
          :initial-view="initialView"
          :minimum-view="minimumView"
          :maximum-view="maximumView"
          :disabled-dates="datesDisabled"
        />
        <span class="errorMessage" v-show="classname">&nbsp;&nbsp;
          <img class="imgClass" src="@/assets/error.svg"/>&nbsp;{{errormsg}}
        </span>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  // ...
  components: {
    Datepicker
  },
  props: {
    value: String|Date,
    label: String,
    errormsg : String,
    classname: Boolean,
    name:String,
    disable: Boolean,
    initialView: String,
    validations : {
       type: String
    },
    formatDate :  {
       type: String,
       default:'dd-MMM-yyyy'
    },
    minimumView :  {
       type: String
    },
    maximumView :  {
       type: String
    },
    datesDisabled: {
      type: Object
    },
    openDate:{
      type:String|Date
    },
    placeholder:{
      type:String,
      default:"Select date"
    }

    },
  data(){
    return{
      date: this.value
    }
  },
  watch:{
    date: function(val){
      if(val){
        let d = new Date(val)
         let value = d.getFullYear()+'-'+('0' + (d.getMonth()+1)).slice(-2)+'-'+('0' + (d.getDate())).slice(-2)
         this.$emit('datevalue', value, d);
         this.$emit('blur');// PL_2453
      }
    },
    value: function(v){
      this.date=v
      // //console.log('value',v)
    }
  },

  methods: {
    onSelected: function(value) {
      // //console.log('selected',v)
      this.$emit('dateChanged', value);
      return value
    },

  },

}
</script>

<style lang="scss">
@import '@/scss/_variables.scss';
.datepicker{
   input {
    background: #fff url("../assets/ic_calendar.svg") 97% 50% no-repeat;
    width: 100%;
    max-width: 300px;
    height: 35px;
    color: #444444;
    font-weight: 400;
    border: 1px solid #dadada;
    border-radius: 4px;
    padding: 10px;
    &:focus{
      border: 1px solid $color-secondary;
      outline: 0px;
    }
    &[disabled='disabled'],&.disabled {
      background-color: #dadada;
    }
    }
    .vdp-datepicker__calendar {
      border: 1px solid $color-secondary;
      margin-top: 1px;
      border-radius: 4px;
      .day__month_btn {
        font-size: $font-size-base;
        color: #646464;
        font-weight: 500;
      }
      .cell.day.selected {
        border-radius: 50%;
        width: 25px;
        height: 25px;
        line-height: 25px;
        background-color: #c7efef;
      }
    }
    .vdp-datepicker__calendar header .next:after {
          border-left: 5px solid #c7efef;
    }
    .vdp-datepicker__calendar header .prev:after {
        border-right: 5px solid #c7efef;
    }
}

.errorMessage{
      padding-top: 5px !important;
      display: inline-block;
}
.errorr {
    border-radius: 4px;
}

.errorMessage{
      padding-top: 5px !important;
      display: inline-block;
}
.errorr {
    border-radius: 4px;
}
</style>
